export default [
  {
    path: '/pages/error/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('./ComingSoon.vue'),
    meta: {
      layout: 'full',
      unused: true,
    },
  },
  {
    path: '/pages/error/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('./UnderMaintenance.vue'),
    meta: {
      layout: 'full',
      unused: true,
    },
  },
]